import { Component, ElementRef, ViewChild, OnInit, inject } from '@angular/core';

import { Store } from '@ngxs/store';
import { Account } from '@core/models';
import { AccountState } from '@state/account/state';
import { FormFieldComponent } from '../form-field.types';
import { CurrencyMaskOptions, getCurrencyMask } from '@shared/Utils/common.utils';

@Component({
  templateUrl: './money-form-field.component.html',
  styleUrls: ['./../form-field.component.scss'],
})
export class MoneyFormFieldComponent extends FormFieldComponent implements OnInit {
  @ViewChild('inputControl') inputControl: ElementRef;

  private account: Account;
  private _originalValue: any;
  private precision: number = 0;

  public value: any;
  public editing: boolean = false;

  private readonly store = inject(Store);

  get currencyMaskOptions(): CurrencyMaskOptions {
    return getCurrencyMask(this.account?.display_currency || 'USD', this.precision);
  }

  constructor() {
    super();
    this.account = this.store.selectSnapshot(AccountState.getAccount);
  }

  get displayValue(): string | number {
    return 'REDACTED';
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.model[this.fieldDef.name];

    this._originalValue = this.value;

    if (this.fieldDef.meta && this.fieldDef.meta.scale !== null && this.fieldDef.meta.scale !== undefined) {
      this.precision = this.fieldDef.meta.scale;
    }
  }

  updateChangedModel(model: any): void {
    this.model = model;
    this.value = this.model[this.fieldDef.name];
    this._originalValue = this.value;
  }

  edit(): void {
    if (!this.editing && !this.isReadonly) {
      this.editing = true;
      setTimeout(() => {
        this.inputControl.nativeElement.focus();
      }, 300);
    }
  }

  onBlur(): void {
    if (this.value === '') {
      this.value = null;
    }
    this.onSave();
    this.editing = false;
  }

  private onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }
}
